import { createApp } from 'vue';
import { router, setupRouter } from '@/router';
import { setupStore } from '@/store';
import { setupRouterPermission } from '@/router/permission';
import App from './App.vue';
import 'vant/es/toast/style';
import 'vant/es/notify/style';
import './styles/index.less';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// import tracker from '@/utils/slsUtil';
import * as Sentry from '@sentry/vue';
const app = createApp(App);
// 获取当前的环境变量
const baseUrl = import.meta.env.VITE_APP_BASE_URL;

// 根据不同的环境生成对应的正则表达式
const networkDetailAllowUrls = [
  // `${baseUrl}/dt/portal/*`,
  new RegExp(`^${baseUrl.replace(/\./g, '\\.')}/dt/portal/.*`),
];

// const networkDetailAllowUrls = [new RegExp(`^${baseUrl.replace(/\./g, '\\.')}/portal/v1/.*`)];
try {
  console.log('🚀 ~ networkDetailAllowUrls:', networkDetailAllowUrls);
  Sentry.init({
    app,
    dsn: 'https://152b73d2bca67178f1adec076bffa5ca@sentry.airdoc.com/3',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        networkDetailAllowUrls,
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
        // VITE_APP_BASE_URL
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // 错误回放上报的频率，0.1为只上报10%的用户
    replaysSessionSampleRate: 0.1,
    environment: import.meta.env.VITE_APP_BASE_ENV,
    // 错误上报的频率，1为全部上报
    replaysOnErrorSampleRate: 1.0,
  });
} catch (error) {
  console.error(error);
}

setupRouter(app);
setupStore(app);
setupRouterPermission(router);
app.mount('#app');
